import { queryOptions } from '@tanstack/react-query'

import { getBankCodes } from './get-bank-codes'

export const accountQueries = {
  all: () => ['accounts'],
  bankCodes: () =>
    queryOptions({
      queryKey: [...accountQueries.all(), 'bank-codes'],
      queryFn: getBankCodes,
    }),
}
